import { Pipe, PipeTransform } from '@angular/core';
import { ToLowerCase } from '@apply4u/shared/helpers/common/string-helpers';
import { IsNotNull, IsNotNullOrEmpty, IsNotZero } from '@apply4u/shared/helpers/common/type-safe-helpers';
import { FormatSeoUrl } from '@apply4u/shared/helpers/seo-helper';
import { LocalstorageService } from '@apply4u/services/localstorage.service';

@Pipe({
  name: 'CompanyProfileUrlPipe',
  standalone:true
})
export class CompanyProfileUrlPipe implements PipeTransform {

  constructor(private localStorage: LocalstorageService) { }

  transform(companyName: string, companyId: number, isSearch: boolean): string {
    let companyUrl = "";

    if (IsNotNullOrEmpty(companyName) && IsNotZero(companyId)) {
      let companyTitle = companyName;
      companyTitle = FormatSeoUrl(companyTitle);
      companyTitle = ToLowerCase(companyTitle);
      companyUrl = `/companies/${companyTitle}-profile-${companyId}`;
    }

    if (IsNotNull(isSearch)) {
      this.localStorage.SetItem('IsJobSearchLink', isSearch.toString());
    }

    return companyUrl;
  }
}